import React, { useState, useEffect } from 'react';
import LogoFI from './LogoFI';
import PL from './PL';
import Salaires from './Salaires';
import TableauOrga from './TableauOrga';
import Projets from './Projets';
import TachesSensibles from './TachesSensibles';
import Donnees from './Donnees';
import Economies from './Economies';
import './Dashboard.css';

const MODULES = [
  { id: 'pl', icon: '📊', label: 'P&L' },
  { id: 'salaires', icon: '👥', label: 'Salariés' },
  { id: 'organigramme', icon: '🗂️', label: 'Organigramme' },
  { id: 'tableau', icon: '🧩', label: 'Tableau' },
  { id: 'projets', icon: '📐', label: 'Projets' },
  { id: 'taches', icon: '🔔', label: 'Taches' },
  { id: 'donnees', icon: '🛢️', label: 'Données' },
  { id: 'economies', icon: '💰', label: 'Économies' },
];

export default function Dashboard({ user, onLogout }) {
  const [activePage, setActivePage] = useState('pl');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, [activePage]);

  const isAdmin = user.role === 'admin';

  return (
    <div className="app-layout">
      {sidebarOpen && <div className="sidebar-backdrop visible" onClick={() => setSidebarOpen(false)} />}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-logo">
          <span className="sidebar-logo-icon"><LogoFI size={36} /></span>
          <span className="sidebar-logo-text">Finance</span>
        </div>

        <nav className="sidebar-nav">
          {MODULES.map(m => (
            <button
              key={m.id}
              className={`sidebar-item ${activePage === m.id ? 'active' : ''}`}
              onClick={() => setActivePage(m.id)}
            >
              <span className="sidebar-item-icon">{m.icon}</span>
              <span className="sidebar-item-label">{m.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <span className="sidebar-user-name">{user.prenom} {user.nom}</span>
            <span className="sidebar-user-role">{user.role}</span>
          </div>
          <button className="sidebar-logout" onClick={onLogout}>Deconnexion</button>
        </div>
      </aside>

      <main className="main-content">
        <header className="page-header">
          <div className="page-header-title">
            <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)} aria-label="Menu">
              ☰
            </button>
            <span className="header-page-icon">
              {MODULES.find(m => m.id === activePage)?.icon}
            </span>
            <h1>{MODULES.find(m => m.id === activePage)?.label}</h1>
          </div>
        </header>

        <div className="page-body">
          {activePage === 'pl' && <PL user={user} isAdmin={isAdmin} />}
          {activePage === 'salaires' && <Salaires user={user} isAdmin={isAdmin} />}
          {activePage === 'organigramme' && <Salaires user={user} isAdmin={isAdmin} mode="organigramme" />}
          {activePage === 'tableau' && <TableauOrga user={user} isAdmin={isAdmin} />}
          {activePage === 'projets' && <Projets user={user} isAdmin={isAdmin} />}
          {activePage === 'taches' && <TachesSensibles user={user} isAdmin={isAdmin} />}
          {activePage === 'donnees' && <Donnees />}
          {activePage === 'economies' && <Economies isAdmin={isAdmin} />}
        </div>
      </main>
    </div>
  );
}
